export default __webpack_public_path__ + "static/5-fe94a6eb376aed71e998ab3130f9c4f0.jpeg";